export const chunk = (arr, len) => {
  var chunks = [],
    i = 0,
    n = arr.length;
  while (i < n) {
    chunks.push(arr.slice(i, (i += len)));
  }
  return chunks;
};

export const flattener = (arr, defaults) => {
  let result = {};
  // Build the results
  for (let key in defaults) {
    let newkey = '';
    let res = arr.filter(foo => foo['Name'] === key);
    if (key.startsWith('custom:')) {
      newkey = key.slice(7);
      defaults[newkey] = defaults[key];
      delete defaults[key];
    } else {
      newkey = key;
    }
    if (res.length > 0) {
      result[newkey] = res[0]['Value'];
    }
  }
  return { ...defaults, ...result };
};



// WEBPACK FOOTER //
// ./src/utils/utilities.js